import React from 'react';

interface Props {
  name: string;
}

/**
 * Full-screen entry splash that mirrors the IAM "Entrando a {project}" overlay pixel-for-pixel.
 * Self-contained: inline styles + <style> block — no dependency on Tailwind or any CSS framework.
 * Shown while the handoff exchange + auth bootstrap is in progress so the user perceives
 * the IAM → app navigation as a single continuous black transition.
 */
export function EnteringSplash({ name }: Props) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: '#0a0a0a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 24,
          animation: 'esf-fadeUp 400ms cubic-bezier(0,0,.2,1) both',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <p
            style={{
              color: '#6b7280',
              fontSize: 12,
              textTransform: 'uppercase',
              letterSpacing: '0.3em',
              margin: '0 0 12px',
              fontFamily: 'inherit',
            }}
          >
            Entrando a
          </p>
          <h1
            style={{
              color: '#ffffff',
              fontSize: 24,
              fontWeight: 600,
              letterSpacing: '-0.025em',
              margin: 0,
              fontFamily: 'inherit',
            }}
          >
            {name}
          </h1>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.6)',
                animation: `esf-dotPulse 1.2s ${i * 0.15}s ease-in-out infinite`,
              }}
            />
          ))}
        </div>
      </div>
      <style>{`
        @keyframes esf-fadeUp {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes esf-dotPulse {
          0%, 100% { opacity: 0.3; transform: scale(0.8); }
          50%       { opacity: 1;   transform: scale(1.3); }
        }
      `}</style>
    </div>
  );
}
